
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { useState } from "react";

export default function LogoutButton() {
  const navigate = useNavigate();
  const { setUser } = useAppContext();
  const [open, setOpen] = useState(false);

  const handleConfirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    setUser(null);
    toast.success("Logged out successfully");
     navigate("/", { replace: true });
  };

  return (
    <>
      {/* Logout Button */}
      <Button
        variant="contained"
        color="error"
        startIcon={<LogoutIcon />}
        sx={{ borderRadius: 2, textTransform: "none", px: 3 }}
        onClick={() => setOpen(true)}
      >
        Logout
      </Button>
      {/* Confirmation Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 3,
            textAlign: "center",
            p: 2
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Confirm Logout
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
            sx={{ borderRadius: 2, textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmLogout}
            sx={{ borderRadius: 2, textTransform: "none" }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}